import React from "react";
import BotChatBlock from "../../../Shared/Components/BotChatBlock/BotChatBlock";
import UserChatBlock from "../../../Shared/Components/UserChatBlock/UserChatBlock";
import LoadingChatBlock from "../../../Shared/Components/LoadingChatBlock/LoadingChatBlock";
import DateStamp from "../../../Shared/Components/DateStamp/DateStamp";
import Disclaimer from "../../../Shared/Components/Disclaimer/Disclaimer";
import LangDisclaimer from "../../../Shared/Components/LangDisclaimer/LangDisclaimer";
import { generateSpeech } from "../../../Actions/ChatActions";

const ChatQueueBlock = ({
  idx,
  followingIdx,
  isLastChatBlock = false,
  selectedLanguage,
  isLoading,
  item,
  username,
  micStatus,
  date,
  speakerEnabled,
  playAudio = () => {},
  stopAudio = () => {},
  setSpeakerEnabled = () => {},
  openSourceDialog = () => {},
  sendFeedback = () => {},
  showDate,
  showLang,
  textSize,
  submitResponse = () => {},
  disabled,
  markFavourite = () => {},
  setToastErrorMessage = () => {},
  setShowToastMessage = () => {},
  start,
  setStartTour,
  onTourEnd,
  speakerOpen,
  setSpeakerOpen,
  defaultQuestionChipsClicked,
  setDefaultQuestionChipsClicked,
  questionChipClicked = () => {},
  showNewChatPrompt = false,
  pendingNewChat = false,
  onNewChatClick = () => {},
}) => {

  const getSpeechString = (title, options, language) => {
    let optionStr = "";
    if (options?.length > 0) {
      options.forEach((option) =>{
        optionStr = optionStr + " " + option[language] + ".";
      });
    }
    return title + optionStr 
  }

  const initSpeechSynth = async (index, title, options, language = selectedLanguage) => {
    if (!micStatus) {
      setSpeakerEnabled(index);
      const res = await generateSpeech(
        getSpeechString(title, options, language),
        language,
        item?._id || null,
      );
      if (res?.data?.url) {
        playAudio(res?.data?.url);
      }
      else {
        setToastErrorMessage(res?.data?.detail)
        setShowToastMessage(true);
        setSpeakerEnabled(false);
      }
      
    }
  };

  return (
    <div className="block relative">
      {showLang && (
        <div className="flex justify-center pb-2">
          <LangDisclaimer selectedLanguage={item?.user?.language} />
        </div>
      )}
      {showDate && (
        <div className="flex flex-col items-center justify-center py-4 gap-2">
          <DateStamp dateValue={date} />
          <Disclaimer 
          selectedLanguage={selectedLanguage}
          />
        </div>
      )}
      <div className="flex flex-col">
        <div className="md:px-6 px-2 py-2">
          {item && item["user"] && item["user"]["text"] && (
            <UserChatBlock
              selectedLanguage={selectedLanguage}
              text={item["user"]["text"]}
              image={item["user"]["image"]}
              textSize={textSize}
            />
          )}
        </div>
        <div className="relative">
          {isLoading && item.dummy ? (
            <LoadingChatBlock />
          ) : (
            item &&
            item["bot"] && (
              <BotChatBlock
                idx={idx}
                followingIdx={followingIdx}
                welcomeIdx={idx + 0.2}
                isLastChatBlock={isLastChatBlock}
                selectedLanguage={selectedLanguage}
                item={item}
                username={username}
                speakerEnabled={speakerEnabled}
                initSpeechSynth={initSpeechSynth}
                stopAudio={stopAudio}
                openSourceDialog={openSourceDialog}
                time={date.toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                })}
                textSize={textSize}
                sendFeedback={sendFeedback}
                saveResponse={submitResponse}
                disabled={disabled}
                markFavourite={markFavourite}
                start={start}
                setStartTour={setStartTour}
                onTourEnd={onTourEnd}
                speakerOpen={speakerOpen}
                setSpeakerOpen={setSpeakerOpen}
                defaultQuestionChipsClicked={defaultQuestionChipsClicked}
                setDefaultQuestionChipsClicked={setDefaultQuestionChipsClicked}
                questionChipClicked={questionChipClicked}
                showNewChatPrompt={showNewChatPrompt}
                pendingNewChat={pendingNewChat}
                onNewChatClick={onNewChatClick}
                isLoading={isLoading}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatQueueBlock;
